import { AsyncPipe } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { CurrencyFormatPipe } from '@shared/pipes';


@Component({
    selector: 'app-currency-value',
    imports: [
        CurrencyFormatPipe,
        AsyncPipe,
    ],
    templateUrl: './currency-value.html',
    styleUrl: './currency-value.scss',
})
export class CurrencyValue {
    public readonly value: InputSignal<number | string> = input();
}
